import { KeyValueModel } from "model/api";
import { EnumTipoOperacaoCardapio } from "model/enums/enum-tipo-operacao-cardapio";

export const TpOperacaoCardapio: KeyValueModel[] = [
    new KeyValueModel(EnumTipoOperacaoCardapio.MESA, "Mesa"),
    new KeyValueModel(EnumTipoOperacaoCardapio.MESACOMANDA, "Mesa e Comanda"),
    new KeyValueModel(EnumTipoOperacaoCardapio.VISUALIZACAO, "Visualização"),
];
